<template>
    <v-container fluid fill-height class="text-center d-flex align-center justify-center"
        style="max-width: 300px; min-width: 300px">

        <div class="Absolute-Center">

        </div>

    </v-container>
</template>

<script>

import router from ".././router";


export default {

    mounted: async function () {



        var v_id = atob(this.$route.params.id);

        var elements = v_id.split("|");

        console.log("ELEMENTS: ", elements);


        window.nomeCandidato = elements[0];
        window.cognomeCandidato = elements[1];
        window.emailCandidato = elements[2];
        window.idAziendaCandidato = elements[3];
        window.tipoContrattoCandidato = elements[4];

        router.push({
            path: "/datiCollaboratore"
        });


    },

    data: () => ({
        showPicker: false,

    }),

    methods: {




    },
};
</script>
